module.exports = __webpack_public_path__ + "static/img/pic_jjxc_bg@2x.c67d3e63.png";